import { Col, DatePicker, Form, Input, Radio, Row, Select } from "antd";
import React, { FC } from "react";
import { IFetchAllDetails } from "../../../../../interfaces/IPatient";

type VisitProps = {
  formattedAdmissionTypeOp: Array<{ label: string; value: string }>;
  form: any;
  portalData: any;
  patientStore: IFetchAllDetails | null;
  isApproved: boolean;
};

const Visit: FC<VisitProps> = (props) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  return (
    <>
    <div
        style={{
          textDecoration: "underline",
          fontSize: "18px",
          marginBottom: "6px",
          fontWeight: "bold"
        }}
      >
        Visit Details
      </div>
    <Form
      form={props?.form}
      //   onFinish={handleSubmit}
      labelAlign="left"
      layout="vertical"
      labelWrap
      style={{ width: "100%" }}
    >
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            label="BENEFICIARY ID"
            name="beneficiaryId"
            style={{ color: "#575757" }}
            rules={[
              {
                required: true,
                message: "Please input BENEFICIARY ID",
              },
            ]}
          >
            <Input
              placeholder="Please input BENEFICIARY ID"
              style={{ color: "black" }}
              disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            label="IPD/OPD NO"
            name="patientOpdIpdNumber"
            style={{ color: "#575757" }}
            rules={[
              {
                required: true,
                message: "Please input Ipd no",
              },
            ]}
          >
            <Input
              placeholder="Please input Ipd No"
              style={{ color: "black" }}
              disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
            />
          </Form.Item>
        </Col>

        {/* <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            label="VISIT TYPE"
            name="visitType"
            style={{ color: "#575757" }}
            rules={[
              {
                required: true,
                message: "Please select VISIT TYPE",
              },
            ]}
          >
            <Select
              showSearch
              placeholder="Select a ADMISSION TYPE"
              options={props?.formattedAdmissionTypeOp?.map((option) => ({
                value: option?.value,
                label: option?.label,
              }))}
              allowClear
              disabled={props?.portalData?.casePreAuthCghs?.claimId}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item
            label="DATE OF OP/INVESTIGATION/COLLECTION"
            name="proposedDate"
            style={{ color: "black" }}
            rules={[
              {
                required: true,
                message: "Please input DATE OF OP/INVESTIGATION/COLLECTION",
              },
            ]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format={dateFormat}
              disabled={props?.portalData?.casePreAuthCghs?.claimId}
            />
          </Form.Item>
        </Col> */}

        {/* <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            label="MEDICO LEGAL CASE"
            name="isMedicoLegalCase"
            style={{ color: "black" }}
            rules={[
              {
                required: true,
                message: "Please select medico legal case",
              },
            ]}
          >
            <Radio.Group
              disabled={props?.portalData?.casePreAuthCghs?.claimId}
              options={[
                { label: "YES", value: "true" },
                { label: "NO", value: "false" },
              ]}
            />
          </Form.Item>
        </Col> */}

        {/* <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            label="PROCEDURE CONSENT"
            name="procedureConsent"
            style={{ color: "black" }}
            rules={[
              {
                required: true,
                message: "Please select Procedure Consent",
              },
            ]}
          >
            <Radio.Group
              disabled={props?.portalData?.casePreAuthCghs?.claimId}
              options={[
                { label: "YES", value: "true" },
                { label: "NO", value: "false" },
              ]}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={10} lg={10} xl={10}>
          <Form.Item
            label="DATE OF LAST CONSULTATION/RECEIPT OF REPORT SAME AS LIMITATION?"
            name="lastConsultation"
            style={{ color: "black" }}
            rules={[
              {
                required: true,
                message:
                  "Please select DATE OF LAST CONSULTATION/RECEIPT OF REPORT SAME AS LIMITATION",
              },
            ]}
          >
            <Radio.Group
              options={[
                { label: "YES", value: "true" },
                { label: "NO", value: "false" },
              ]}
              disabled={props?.portalData?.casePreAuthCghs?.claimId}
            />
          </Form.Item>
        </Col> */}

        {(props?.patientStore?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        "CAPF" || props?.patientStore?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        "CAPF NEW") ? (
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="REMARKS"
              name="remarks"
              style={{ color: "#575757" }}
            >
              <Input
                placeholder="Please input remarks"
                style={{ color: "black" }}
                disabled={props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted}
              />
            </Form.Item>
          </Col>
        ) : (
          <></>
        )}
      </Row>
    </Form>
    </>
  );
};

export default Visit;
